const generateTaxonomyInitialState = data => {
  const initialState = {};
  data.forEach(item => {
    if (item.value === 'location') {
      initialState[item.value] = {
        taxonomyLabel: item.name,
        taxonomyValue: item.value,
        locationData: [],
        selectedRegionId: 0,
        selectedSubRegionId: 0,
        selectedCountryId: 0,
      };
    } else {
      initialState[item.value] = {
        taxonomyLabel: item.name,
        taxonomyValue: item.value,
        tableData: {
          data: [],
          error: null,
          isError: false,
          isFetching: false,
        },
        formValues: null,
        filter: '',
      };
    }
  });
  return initialState;
};
const drugs = 'drugs';
const trials = 'trials';
const sites = 'sites';
const admin = 'admin';
const paging = 'paging';
const sourceDoc = 'sourceDoc';
const countryRegion = 'countryRegion';
const language = 'language';
const registryAbbreviationName = 'registryAbbreviationName';
const registryFullName = 'registryFullName';
const registryGovernance = 'registryGovernance';
const requirement = 'requirement';
const information = 'information';
const studyType = 'studyType';
const studyPhase = 'studyPhase';
const interventionalType = 'interventionalType';
const regVersion = 'regVersion';
const aCTAbbrivatedName = 'aCTAbbrivatedName';
const docType = 'docType';

var loggedInUserGroup = localStorage.getItem('usergroup');
export const taxonomyValues =
  loggedInUserGroup == 'StarUser'
    ? [
        {
          id: '1',
          name: 'Arm Type',
          value: 'armType',
          tabIdentifier: 'armType',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '10',
          name: 'Assign Patient Segment',
          value: 'diseaseClassification',
          tabIdentifier: 'diseaseClassification',
          group: trials,
          listKey: ['therapeuticArea'],
          primaryField: 'diseaseType.desc',
          editConfirm: true,
        },
        {
          id: '2',
          name: 'Associated CRO',
          value: 'associatedCRO',
          tabIdentifier: 'associatedCRO',
          group: trials,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '1',
          name: 'Central IRB',
          value: 'centralIRB',
          tabIdentifier: 'organizationIRB',
          group: sites,
          primaryField: 'organizationCentralIRB',
        },
        {
          id: '4',
          name: 'Collaborator',
          value: 'collaborator',
          tabIdentifier: 'collaborator',
          group: trials,
          primaryField: 'type',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '5',
          name: 'Collaborator Type',
          value: 'collaboratorType',
          tabIdentifier: 'collaboratorType',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '6',
          name: 'Company',
          value: 'company',
          tabIdentifier: 'company',
          group: paging,
          listKey: ['researchFocus'],
          primaryField: 'name',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '9',
          name: 'Degree',
          value: 'degree',
          tabIdentifier: 'degree',
          group: sites,
          primaryField: 'degree',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '12',
          name: 'Delivery Medium',
          value: 'deliveryMedium',
          tabIdentifier: 'deliveryMedium',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '13',
          name: 'Delivery Route',
          value: 'deliveryRoute',
          tabIdentifier: 'deliveryRoute',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '14',
          name: 'Delivery Technology',
          value: 'deliveryTechnology',
          tabIdentifier: 'deliveryTechnology',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '15',
          name: 'Design Keyword',
          value: 'designKeywords',
          tabIdentifier: 'designKeywords',
          group: trials,
          primaryField: 'designkeyword',
        },
        {
          id: '16',
          name: 'Development Stages',
          value: 'drugDevelopmentStatus',
          tabIdentifier: 'drugDevelopmentStatus',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '11',
          name: 'Drug Country',
          value: 'drugCountry',
          tabIdentifier: 'country',
          group: drugs,
          listKey: ['countryGroup'],
          primaryField: 'countryName',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '8',
          name: 'Drug Country Group',
          value: 'countryGroup',
          tabIdentifier: 'countryGroup',
          group: drugs,
          primaryField: 'name',
        },
        {
          id: '22',
          name: 'Drug Disease',
          value: 'indication',
          tabIdentifier: 'indication',
          group: drugs,
          listKey: ['indicationGroup'],
          primaryField: 'indication',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '23',
          name: 'Drug Disease Group',
          value: 'indicationGroup',
          tabIdentifier: 'indicationGroup',
          group: drugs,
          primaryField: 'name',
        },
        {
          id: '18',
          name: 'Drug Notes Type',
          value: 'notesType',
          tabIdentifier: 'notesType',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '50',
          name: 'DRUG Therapeutic Class',
          value: 'therapeuticClass',
          tabIdentifier: 'therapeuticClass',
          group: drugs,
          primaryField: 'description',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '27',
          name: 'Drug Type',
          value: 'drugType',
          tabIdentifier: 'DrugTypeClassification',
          group: drugs,
          primaryField: 'description',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '20',
          name: 'Endpoint Synonym',
          value: 'endpointSynonyms',
          tabIdentifier: 'EndpointSynonym',
          group: admin,
          listKey: ['EndpointArea'],
          nonAncillaryList: {
            tabIdentifier: 'EndpointArea',
            group: admin,
          },
          primaryField: 'endpointName.preferredEndpointName',
          idAccessor: 'endpointName',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '19',
          name: 'Event Types',
          value: 'eventTypes',
          tabIdentifier: 'eventTypes',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '21',
          name: 'Event Type Group',
          value: 'eventGroup',
          tabIdentifier: 'eventGroup',
          group: drugs,
          primaryField: 'eventGroup',
        },
        {
          id: '58',
          name: 'Immunoconjugate payload',
          value: 'payload',
          tabIdentifier: 'ImmunoconjugatePayload',
          group: drugs,
          primaryField: 'payload',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '24',
          name: 'Journal Name',
          value: 'journalName',
          tabIdentifier: 'journalName',
          group: trials,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '25',
          name: 'License Id Type',
          value: 'licenseIdType',
          tabIdentifier: 'licenseIdType',
          group: sites,
          primaryField: 'description',
        },
        {
          id: '27',
          name: 'Mechanisms',
          value: 'mechanismOfAction',
          tabIdentifier: 'mechanismOfAction',
          group: drugs,
          primaryField: 'description',
          pagination: {
            pageIndex: 1,
            pageSize: 10000,
          },
        },
        {
          id: '28',
          name: 'Meeting/Conference Name',
          value: 'conferenceName',
          tabIdentifier: 'conferenceName',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '29',
          name: 'Organization Type',
          value: 'organizationType',
          tabIdentifier: 'organizationType',
          group: sites,
          primaryField: 'type',
        },
        {
          id: '30',
          name: 'Origin of Material',
          value: 'originOfMaterial',
          tabIdentifier: 'originOfMaterial',
          group: drugs,
          primaryField: 'description',
        },
        {
          id: '31',
          name: 'Patient Segments',
          value: 'patientSegment',
          tabIdentifier: 'patientSegment',
          group: trials,
          listKey: ['diseaseType'],
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '32',
          name: 'Patient Segment Synonym(s)',
          value: 'patientSegmentSynonym',
          tabIdentifier: 'patientSegmentSynonym',
          group: trials,
          primaryField: 'patientSegment.desc',
          hideAddForm: true,
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '52',
          name: 'Person Role',
          value: 'role',
          tabIdentifier: 'role',
          group: trials,
          primaryField: 'roleDescription',
        },
        {
          id: '36',
          name: 'Person Type',
          value: 'personType',
          tabIdentifier: 'personType',
          group: sites,
          primaryField: 'personType',
        },
        {
          id: '33',
          name: 'Pharmacokinetics Parameter',
          value: 'pharmacokineticsParameter',
          tabIdentifier: 'pharmacokineticsParameter',
          group: drugs,
          primaryField: 'parameter',
        },
        {
          id: '34',
          name: 'Pharmacokinetics Unit',
          value: 'pharmacokineticsUnit',
          tabIdentifier: 'pharmacokineticsUnit',
          group: drugs,
          primaryField: 'unit',
        },
        {
          id: '35',
          name: 'Physician ID Type',
          value: 'physicianIdType',
          tabIdentifier: 'physicianIdType',
          group: sites,
          primaryField: 'description',
        },
        {
          id: '38',
          name: 'Regulatory Action Flag',
          value: 'regulatoryActionFlag',
          tabIdentifier: 'regulatoryActionFlag',
          group: sites,
          primaryField: 'flag',
        },
        {
          id: '37',
          name: 'Regulatory Action Type',
          value: 'regulatoryActionType',
          tabIdentifier: 'regulatoryActionType',
          listKey: ['regulatoryActionFlag'],
          group: sites,
          primaryField: 'description',
        },
        {
          id: '39',
          name: 'Research Focus',
          value: 'researchFocus',
          tabIdentifier: 'researchFocus',
          group: sites,
          primaryField: 'description',
        },
        {
          id: '40',
          name: 'Result Type',
          value: 'resultType',
          tabIdentifier: 'resultType',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '3',
          name: 'Sitetrove City',
          value: 'city',
          tabIdentifier: 'city',
          group: sites,
          primaryField: 'cityName',
          editConfirm: true,
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '7',
          name: 'Sitetrove Country',
          value: 'country',
          tabIdentifier: 'country',
          group: sites,
          primaryField: 'countryName',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '45',
          name: 'Sitetrove State',
          value: 'state',
          tabIdentifier: 'state',
          group: sites,
          primaryField: 'stateName',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
          editConfirm: true,
        },
        {
          id: '41',
          name: 'Source Type',
          value: 'sourceType',
          tabIdentifier: 'sourceType',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '42',
          name: 'Specialty',
          value: 'specialties',
          tabIdentifier: 'specialties',
          group: sites,
          primaryField: 'specialties',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '43',
          name: 'SPONSOR/COLLABORATOR',
          value: 'sponsor',
          tabIdentifier: 'Sponsor',
          group: trials,
          listKey: ['sponsorType'],
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '44',
          name: 'SPONSOR/COLLABORATOR TYPE',
          value: 'sponsorType',
          tabIdentifier: 'sponsorType',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '46',
          name: 'Stock Exchange',
          value: 'stockExchange',
          tabIdentifier: 'stockExchange',
          group: sites,
          primaryField: 'exchange',
        },
        {
          id: '47',
          name: 'Target',
          value: 'target',
          tabIdentifier: 'target',
          group: drugs,
          listKey: ['targetFamily'],
          primaryField: 'target',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '48',
          name: 'Target Family',
          value: 'targetFamily',
          tabIdentifier: 'targetFamily',
          group: drugs,
          primaryField: 'targetFamily',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '57',
          name: 'Trial Note Type',
          value: 'noteType',
          tabIdentifier: 'noteType',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '51',
          name: 'Trial Phases',
          value: 'phase',
          tabIdentifier: 'phase',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '53',
          name: 'Trial Source',
          value: 'source',
          tabIdentifier: 'source',
          group: trials,
          primaryField: 'description',
        },
        {
          id: '54',
          name: 'Trial Status',
          value: 'globalStatus',
          tabIdentifier: 'globalStatus',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '55',
          name: 'Trial Tags',
          value: 'tag',
          tabIdentifier: 'tag',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '56',
          name: 'Trial Termination Reason',
          value: 'terminationReason',
          tabIdentifier: 'terminationReason',
          group: trials,
          primaryField: 'desc',
        },
        {
          id: '26',
          name: 'TrialTrove Location',
          value: 'location',
          tabIdentifier: 'location',
          group: sites,
          primaryField: 'description',
        },
        {
          id: '17',
          name: 'Trialtrove Disease Type',
          value: 'diseaseType',
          tabIdentifier: 'diseaseType',
          group: trials,
          listKey: ['therapeuticArea'],
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
          editConfirm: true,
        },
        {
          id: '49',
          name: 'TrialTrove Therapeutic Area',
          value: 'therapeuticArea',
          tabIdentifier: 'therapeuticArea',
          group: trials,
          primaryField: 'desc',
        },
      ]
    : [
        {
          id: '101',
          name: 'Source Name',
          value: 'sourceName',
          tabIdentifier: 'sourceName',
          group: sourceDoc,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '102',
          name: 'Country/Region',
          value: 'countryName',
          tabIdentifier: 'Countries',
          group: countryRegion,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '103',
          name: 'Languages',
          value: 'language',
          tabIdentifier: 'Language',
          group: language,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '104',
          name: 'Registries Abbreviated Name',
          value: 'registryAbbreviation',
          tabIdentifier: 'RegistryAbbreviatedName',
          group: registryAbbreviationName,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '105',
          name: 'Registries Full Name',
          value: 'registryName',
          tabIdentifier: 'RegistryName',
          group: registryFullName,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '106',
          name: 'Registry Governance',
          value: 'registryGovernance',
          tabIdentifier: 'RegistryGovernance',
          group: registryGovernance,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '107',
          name: 'Responsible for data entry',
          value: 'information',
          tabIdentifier: 'ResponsibleForDataEntry',
          group: information,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '108',
          name: 'Requirement/Regulation Abbreviated Name',
          value: 'requirementAbbreviatedName',
          tabIdentifier: 'AbbreviatedName',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '126',
          name: 'Clinical Trial Requirement Abbreviated Name',
          value: 'abbreviatedName',
          tabIdentifier: 'ClinicalTrialAbbreviatedName',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '109',
          name: 'Study Type',
          value: 'studyType',
          tabIdentifier: 'StudyType',
          group: studyType,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '110',
          name: 'Study Phase',
          value: 'studyPhase',
          tabIdentifier: 'StudyPhase',
          group: studyPhase,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '111',
          name: 'Intervention Type For Registries',
          value: 'interventionalType',
          tabIdentifier: 'InterventionalType',
          group: interventionalType,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '112',
          name: 'Document type',
          value: 'docType',
          tabIdentifier: 'DocumentType',
          group: docType,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '113',
          name: 'Regulatory version',
          value: 'regVersion',
          tabIdentifier: 'RegulatoryVersion',
          group: regVersion,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '114',
          name: 'ACT Abbreviated Name',
          value: 'aCTAbbrivatedName',
          tabIdentifier: 'ACTAbbreviatedName',
          group: aCTAbbrivatedName,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '115',
          name: 'CTA Document Type',
          value: 'ctaDocumentType',
          tabIdentifier: 'CTADocumentType',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '116',
          name: 'Submission Type',
          value: 'submissionType',
          tabIdentifier: 'SubmissionType',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '117',
          name: 'Document tags',
          value: 'docTags',
          tabIdentifier: 'DocumentTag',
          group: sourceDoc,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '118',
          name: 'Redaction Registration Information',
          value: 'redactionRegistrationInformation',
          tabIdentifier: 'RedactionRegistrationInformation',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '119',
          name: 'Redaction Results Type',
          value: 'redactionResultType',
          tabIdentifier: 'RedactionResultType',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '120',
          name: 'Redaction Document Type',
          value: 'redactionDocumentType',
          tabIdentifier: 'RedactionDocumentType',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '121',
          name: 'Deferral Document Type',
          value: 'deferralDocumentType',
          tabIdentifier: 'DeferralDocumentType',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '122',
          name: 'HA Funded Registered Documents',
          value: 'hafundedregistereddocuments',
          tabIdentifier: 'HAFundedRegisteredDocuments',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '123',
          name: 'CTA Outcomes',
          value: 'ctaOutcome',
          tabIdentifier: 'CTAOutcomes',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '124',
          name: 'Exemptions to CTA',
          value: 'exemptionsCta',
          tabIdentifier: 'ExemptionsToCTA',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
        {
          id: '125',
          name: 'Exemptions to Ethics Committee',
          value: 'exemptionstoethicsreview',
          tabIdentifier: 'ExemptionsToEthicsReview',
          group: requirement,
          primaryField: 'desc',
          pagination: {
            pageIndex: 1,
            pageSize: 50,
          },
        },
      ];

//sort the option alphbatically

// taxonomyValues.sort((a, b) => {
//   var keyA = a.name,
//     keyB = b.name; // Compare the 2 column values
//   if (keyA < keyB) {
//     return -1;
//   }
//   if (keyA > keyB) {
//     return 1;
//   }
//   return 0;
// });
export const taxonomyInitialState = generateTaxonomyInitialState(taxonomyValues);
